// extracted by mini-css-extract-plugin
module.exports = {"frame":"AnimatedPager-module__frame___cp78D","page":"AnimatedPager-module__page___smkjH"};